import type { Portfolio } from 'venn-api';
import { compact, uniq } from 'lodash';

export const getPortfolioAllocDates = (portfolio?: Portfolio): number[] =>
  compact(
    uniq(
      [
        portfolio?.closingAllocationsTs?.flatMap((ts) => ts[0]!) ?? [],
        portfolio?.children.flatMap((child) => getPortfolioAllocDates(child)),
      ].flat(),
    ),
  ).sort((a, b) => a - b);
const getMaxAllocationDate = (allocations: number[][], now: number) => {
  const lastAlloc = allocations.at(-1);
  return lastAlloc ? (lastAlloc[1] === 0 ? lastAlloc[0] : now) : undefined;
};

const getPortfolioMaxAllocationDates = (portfolio: Portfolio | undefined, now: number): number[] =>
  compact(
    uniq(
      [
        getMaxAllocationDate(portfolio?.closingAllocationsTs ?? [], now),
        portfolio?.children?.flatMap((child) => getPortfolioMaxAllocationDate(child, now)),
      ].flat(),
    ),
  );

export const getPortfolioMaxAllocationDate = (portfolio: Portfolio | undefined, now: number): number | undefined =>
  Math.max(...getPortfolioMaxAllocationDates(portfolio, now));
